import { doc, getDoc } from "firebase/firestore";
import { firestore } from "@redux/firebase";

/**
 * Legge dei documenti di `documents` per id, uno per uno, e restituisce
 * `{ [id]: dati }` con i soli documenti che esistono e che chi chiede puo'
 * leggere.
 *
 * Perche' non `where(documentId(), 'in', lotto)` (STU-480): con le regole che
 * aprono a ognuno solo i propri documenti (piu' quelli condivisi dal docente
 * e il demo), una query `in` si valuta documento per documento e cade TUTTA
 * se uno solo manca o non e' leggibile: un documento cancellato o una
 * condivisione revocata svuotava l'intero storico degli esami. Con un `get`
 * per id ogni documento risponde per se': quello che non c'e' resta fuori,
 * gli altri arrivano. Le letture fatturate sono le stesse (una per documento).
 *
 * Accetta anche contentUUID fra gli id (lo storico ce li mette): un id che non
 * e' un documento torna semplicemente assente.
 */
export const leggiDocumentiPerId = async (ids, db = firestore) => {
  const unici = Array.from(new Set((ids || []).filter((id) => typeof id === 'string' && id)));
  const esiti = await Promise.allSettled(unici.map((id) => getDoc(doc(db, 'documents', id))));
  const trovati = {};
  esiti.forEach((esito) => {
    if (esito.status === 'fulfilled' && esito.value.exists()) {
      trovati[esito.value.id] = esito.value.data();
    }
  });
  return trovati;
};

export default leggiDocumentiPerId;
